var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 304 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.49 52.08h-4.15c-15.9-7.17-75.8-9.44-147.26-9.44S20.73 44.91 4.82 52.08H.68v19.17h.07c2.4 8.77 69.23 15.79 151.33 15.79 82.1 0 148.93-7.03 151.33-15.8h.07V52.09Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.08 68.63c83.62 0 151.4-7.3 151.4-16.3 0-8.99-67.78-16.28-151.4-16.28S.68 43.35.68 52.34c0 9 67.78 16.29 151.4 16.29Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M152.08 68.63c83.62 0 151.4-7.3 151.4-16.3 0-8.99-67.78-16.28-151.4-16.28S.68 43.35.68 52.34c0 9 67.78 16.29 151.4 16.29Z",
    fill: "url(#c)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.49 52.34c-.02.33-.1.66-.26.95-.3.58-.98 1.25-1.96 1.87-1.98 1.25-5.16 2.4-9.25 3.5-8.19 2.17-20.1 4.16-34.44 5.67-28.68 3.08-67.1 4.78-105.5 4.87-38.4-.08-76.82-1.79-105.5-4.87-14.34-1.52-26.25-3.5-34.44-5.67-4.09-1.1-7.26-2.25-9.24-3.5a5.45 5.45 0 0 1-1.96-1.87c-.16-.3-.25-.62-.26-.95.02.33.12.65.28.95.3.57.98 1.22 1.97 1.82 1.98 1.22 5.16 2.33 9.26 3.36 8.2 2.09 20.12 3.77 34.45 5.24 28.67 2.94 67.07 4.44 105.45 4.35 38.38.1 76.78-1.4 105.45-4.35 14.33-1.47 26.26-3.15 34.45-5.24 4.1-1.03 7.28-2.14 9.26-3.36a5.47 5.47 0 0 0 1.98-1.82c.15-.3.24-.62.25-.95Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.25 49.2c0 7.16 59.02 12.96 131.83 12.96s131.84-5.8 131.84-12.96c0-7.16-59.03-12.96-131.84-12.96-72.8 0-131.83 5.8-131.83 12.96Z",
    fill: "url(#e)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.22 30.21h-3.4c-13.04-5.5-62.14-7.24-120.74-7.24-58.6 0-107.7 1.74-120.73 7.24h-3.4v17.83H28c1.96 6.73 56.76 12.13 124.08 12.13 67.31 0 122.1-5.4 124.07-12.13h.06V30.2Z",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.08 42.9c68.56 0 124.14-5.59 124.14-12.5 0-6.9-55.58-12.5-124.14-12.5S27.95 23.5 27.95 30.4c0 6.91 55.57 12.5 124.13 12.5Z",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M152.08 42.9c68.56 0 124.14-5.59 124.14-12.5 0-6.9-55.58-12.5-124.14-12.5S27.95 23.5 27.95 30.4c0 6.91 55.57 12.5 124.13 12.5Z",
    fill: "url(#h)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.22 30.4c-.01.26-.09.51-.21.74-.25.44-.8.95-1.61 1.43-1.63.96-4.23 1.85-7.58 2.69-6.71 1.66-16.48 3.18-28.24 4.35-23.52 2.37-55 3.67-86.5 3.74-31.48-.06-62.97-1.39-86.49-3.74-11.76-1.17-21.52-2.68-28.24-4.35-3.35-.83-5.95-1.73-7.57-2.7a4.36 4.36 0 0 1-1.61-1.42 1.7 1.7 0 0 1-.22-.74c.02.26.1.51.23.73.24.44.8.94 1.61 1.4 1.63.94 4.24 1.79 7.6 2.59 6.72 1.6 16.5 2.88 28.24 4.02 23.51 2.25 55 3.4 86.46 3.32 31.47.09 62.95-1.07 86.46-3.32 11.75-1.14 21.53-2.42 28.25-4.02 3.36-.8 5.96-1.65 7.59-2.59a4.23 4.23 0 0 0 1.62-1.4c.12-.22.2-.47.2-.73Z",
    fill: "url(#i)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M152.08 38.21c59.48 0 107.7-4.42 107.7-9.88 0-5.45-48.22-9.88-107.7-9.88-59.48 0-107.7 4.43-107.7 9.88 0 5.46 48.22 9.88 107.7 9.88Z",
    fill: "url(#j)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 10.37h-2.77c-10.65-4.2-50.77-5.52-98.64-5.52s-87.98 1.33-98.63 5.52H50.7v16.9h.04c1.61 5.13 46.38 9.24 101.37 9.24s99.76-4.11 101.36-9.24h.05l-.03-16.9Z",
    fill: "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.08 20.05c56.01 0 101.41-4.27 101.41-9.53S208.1 1 152.1 1C96.06 1 50.66 5.26 50.66 10.52s45.4 9.53 101.41 9.53Z",
    fill: "url(#l)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M152.08 20.05c56.01 0 101.41-4.27 101.41-9.53S208.1 1 152.1 1C96.06 1 50.66 5.26 50.66 10.52s45.4 9.53 101.41 9.53Z",
    fill: "url(#m)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 10.52c-.01.2-.07.39-.18.56-.34.46-.8.84-1.31 1.09-1.33.73-3.45 1.4-6.2 2.05-5.48 1.27-13.46 2.42-23.06 3.32-19.22 1.8-44.94 2.8-70.67 2.85-25.72-.05-51.45-1.05-70.66-2.85-9.61-.9-17.58-2.04-23.07-3.32-2.74-.65-4.87-1.32-6.2-2.05a3.48 3.48 0 0 1-1.3-1.1c.35.46.8.83 1.32 1.07 1.33.72 3.46 1.36 6.2 1.97 5.5 1.22 13.48 2.21 23.08 3.07 19.2 1.72 44.92 2.6 70.63 2.54 25.7.06 51.43-.84 70.64-2.54 9.6-.87 17.58-1.85 23.07-3.07 2.75-.6 4.88-1.25 6.2-1.97.53-.24.98-.6 1.32-1.06.11-.17.17-.36.19-.56Z",
    fill: "url(#n)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.68,
    y1: 64.84,
    x2: 303.49,
    y2: 64.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#441700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6B2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#702500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#772800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#893202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A84104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C45006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AF4804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#893801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7A3200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#883801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#AD4805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E8620A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A44005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#792A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#682200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#551C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.68,
    y1: 52.34,
    x2: 303.49,
    y2: 52.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.68,
    y1: 60.77,
    x2: 303.49,
    y2: 60.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5B361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B25B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E67228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F77929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E67128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B15B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8A4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5A361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 689108,
    y1: 47744.3,
    x2: 912165,
    y2: 47744.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#441700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6B2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#702500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#772800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#893202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A84104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C45006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AF4804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#893801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7A3200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#883801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#AD4805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E8620A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A44005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#792A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#682200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#551C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 24524.9,
    y1: 2673.26,
    x2: 247578,
    y2: 2673.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 689069,
    y1: 16415.3,
    x2: 912114,
    y2: 16415.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5B361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B25B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E67228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F77929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E67128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B15B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8A4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5A361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 579657,
    y1: 38238.6,
    x2: 728522,
    y2: 38238.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#301000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#441700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5C1F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6B2300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#702500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#772800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#893202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A84104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C45006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AF4804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#893801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7A3200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#883801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#AD4805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E8620A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A44005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#792A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#682200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#551C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 36741.7,
    y1: 656.59,
    x2: 185607,
    y2: 656.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 579657,
    y1: 11739.5,
    x2: 728522,
    y2: 11739.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#5B361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B25B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E67228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F77929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F37729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E67128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D06826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B15B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8A4A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5A361E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(208.172 0 0 18.7804 152.08 38.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F89150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA894C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D37B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3683A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8A502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#844D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7C492A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#663F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#432F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(131.954 0 0 13.0339 153.59 50.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#331704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#351906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3A1F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#442A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#513A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#634E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#79675B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#94857B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D5CFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(153412 0 0 1390.77 799879 63996.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F89150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA894C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D37B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3683A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8A502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#844D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7C492A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#663F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#432F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(84025.5 0 0 703.166 1143610 11011.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#331704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#351906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3A1F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#442A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#513A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#634E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#79675B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#94857B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B2A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D5CFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(102351 0 0 769.378 653350 42205.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F89150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA894C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D37B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#B3683A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8A502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#844D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7C492A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#663F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#432F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.702579f24f53d5b0c8724f337d1206a0.svg";
export { ForwardRef as ReactComponent };